// Utilidades para coordenadas (latitud/longitud) del módulo de validación.
//
// Centraliza el formateo "lat,lng" y la copia al portapapeles, para que
// Origen/Destino, Escalas y el Mapa compartan el mismo comportamiento.

// ¿El par (lat,lng) es un punto numérico válido?
export const hasCoords = (lat, lng) =>
  Number.isFinite(Number(lat)) && Number.isFinite(Number(lng))

// Formatea un par de coordenadas como "lat,lng" con 6 decimales (precisión
// típica de geolocalización). Devuelve null si el punto no es válido.
export const formatCoords = (lat, lng, decimals = 6) => {
  if (!hasCoords(lat, lng)) return null
  return `${Number(lat).toFixed(decimals)},${Number(lng).toFixed(decimals)}`
}

// Copia texto al portapapeles. Usa la Clipboard API cuando está disponible y
// cae a un textarea temporal (document.execCommand) en contextos sin ella
// (p. ej. http sin secure context). Devuelve Promise<boolean> de éxito.
export const copyToClipboard = async (text) => {
  if (text == null || text === "") return false
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(String(text))
      return true
    }
  } catch (_e) {
    // cae al fallback
  }
  try {
    const ta = document.createElement("textarea")
    ta.value = String(text)
    ta.style.position = "fixed"
    ta.style.opacity = "0"
    document.body.appendChild(ta)
    ta.focus()
    ta.select()
    const ok = document.execCommand("copy")
    document.body.removeChild(ta)
    return ok
  } catch (_e) {
    return false
  }
}

// Copia el par (lat,lng) formateado. Devuelve Promise<boolean>. No-op (false)
// si el punto no es válido.
export const copyCoords = async (lat, lng, decimals = 6) => {
  const txt = formatCoords(lat, lng, decimals)
  if (txt == null) return false
  return copyToClipboard(txt)
}
